import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mark-management',
  templateUrl: './mark-management.component.html',
  styleUrls: ['./mark-management.component.css']
})
export class MarkManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {  
  }

}
